/**
 * Ürün kartlarında varyant seçimi + "Sepete ekle".
 * snippets/kuruca-card-add.liquid ile üretilen [data-kca] alanlarını yönetir.
 * Belge düzeyinde olay delegasyonu kullandığı için filtre/sayfalama ile sonradan eklenen kartlarda da çalışır.
 * Sepet güncellemesi temasın kendi olayı (CartLinesUpdateEvent) ile yapılır.
 * Varyant seçilince kartın fiyat yazısı da (indirimliyse eski fiyatla birlikte) güncellenir.
 */
import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

const setMessage = (root, text) => {
  const el = root.querySelector('[data-kca-message]');
  if (el) el.textContent = text;
};

/** Temasın fiyat bileşenini (product-price) seçilen varyanta göre yeniden çizer. */
function syncCardPrice(root, option) {
  const card = root.closest('product-card');
  const container = card && card.querySelector('product-price [ref="priceContainer"]');
  if (!container) return;

  const makeGroup = (className, hiddenLabel, amount) => {
    const group = document.createElement('span');
    group.className = className;
    if (hiddenLabel) {
      const hidden = document.createElement('span');
      hidden.className = 'visually-hidden';
      hidden.textContent = hiddenLabel + ' ';
      group.append(hidden);
    }
    const bdi = document.createElement('bdi');
    bdi.textContent = amount;
    group.append(bdi);
    return group;
  };

  container.textContent = '';
  if (option.dataset.compare) {
    container.append(
      makeGroup('price-item__group price-item--regular compare-at-price', 'Normal fiyat', option.dataset.compare),
      document.createTextNode(' '),
      makeGroup('price-item__group price', 'İndirimli fiyat', option.dataset.price)
    );
  } else {
    const price = document.createElement('span');
    price.className = 'price';
    const bdi = document.createElement('bdi');
    bdi.textContent = option.dataset.price;
    price.append(bdi);
    container.append(price);
  }
}

// Kartın içindeki tema olayları (görsel geçişi vb.) buton tıklamasını etkilemesin
document.addEventListener(
  'click',
  (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target || !target.closest('[data-kca]')) return;
    event.stopPropagation();

    const button = target.closest('[data-kca-add]');
    if (button) {
      event.preventDefault();
      addToCart(button);
    }
  },
  true
);

document.addEventListener('change', (event) => {
  const select = event.target instanceof Element ? event.target.closest('[data-kca-variant]') : null;
  if (!select) return;

  const root = select.closest('[data-kca]');
  const option = select.selectedOptions[0];
  const button = root && root.querySelector('[data-kca-add]');
  if (!root || !option || !button) return;

  const available = option.dataset.available === 'true';
  button.dataset.variantId = option.value;
  button.disabled = !available;
  const label = button.querySelector('[data-kca-label]');
  if (label) label.textContent = available ? root.dataset.add : root.dataset.soldOut;
  setMessage(root, '');
  syncCardPrice(root, option);
});

async function addToCart(button) {
  if (button.disabled || button.dataset.busy === 'true') return;

  const root = button.closest('[data-kca]');
  const label = button.querySelector('[data-kca-label]');
  const select = root.querySelector('[data-kca-variant]');
  const variantId = String(select ? select.value : button.dataset.variantId);
  const idleText = label.textContent;

  button.dataset.busy = 'true';
  button.disabled = true;
  label.textContent = root.dataset.adding;
  setMessage(root, '');

  const sectionIds = [
    ...new Set(
      [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean)
    ),
  ];

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', '1');
  if (sectionIds.length) formData.append('sections', sectionIds.join(','));

  const deferred = CartLinesUpdateEvent.createPromise();
  root.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: variantId, quantity: 1 }],
      promise: deferred.promise,
    })
  );

  const addUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';

  try {
    const response = await fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    });
    const result = await response.json();
    const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    const ajaxCart = await cartResponse.json();
    const cart = CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart);

    if (!response.ok || result.status) {
      const message = result.description || result.message || 'Sepete eklenemedi.';
      root.dispatchEvent(
        new CartErrorEvent({
          error: message,
          code: 'INVALID',
          detail: { description: result.description, errors: result.errors },
        })
      );
      deferred.resolve({
        cart,
        detail: {
          didError: true,
          items: ajaxCart.items,
          source: 'kuruca-card-add',
          sourceId: variantId,
          itemCount: 1,
        },
      });
      label.textContent = idleText;
      button.disabled = false;
      setMessage(root, message);
      return;
    }

    deferred.resolve({
      cart,
      detail: {
        items: ajaxCart.items,
        source: 'kuruca-card-add',
        sourceId: variantId,
        itemCount: 1,
        sections: result.sections,
        didError: false,
      },
    });

    label.textContent = root.dataset.added;
    setTimeout(() => {
      label.textContent = idleText;
      button.disabled = false;
    }, 2000);
  } catch (error) {
    deferred.reject(error);
    label.textContent = idleText;
    button.disabled = false;
    setMessage(root, 'Bir sorun oluştu, lütfen tekrar deneyin.');
  } finally {
    delete button.dataset.busy;
  }
}
